import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { useInformMechanicalStore } from "../../hooks/useInformMechanicalStore";
import { InformMechanical } from "../../types/slices/informMechanicalType";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { WorkDone } from "../../types/slices/workDondeType";
import { useReplacementPartStore } from "../../hooks/useReplacementPartStore";
import { ReplacementPart } from "../../types/slices/replacementPartType";

const columns = [
    { type: 'options', field: 'options', label: 'OPCIONES', align: 'center' },
    { type: 'text', field: 'code', label: 'CÓDIGO', align: 'center' },
    { type: 'text', field: 'name', label: 'REPUESTO', align: 'center' },
    { type: 'text', field: 'stock', label: 'STOCK', align: 'center' },
    { type: 'detail', field: 'detail', label: '', align:'center' },
]

export const ReplacementPartList:FC = () => {
    const navigate = useNavigate()
    const { search } = useSelector(selectHeaderState)
    const { status, replacementParts, getReplacementParts, deleteReplacementPart, setEditReplacementPart } = useReplacementPartStore()

    const [ loading, setLoading ] = useState<boolean>(false)
    const [ page, setPage ] = useState<number>(0)
    const [ rowsPerPage, setRowsPerPage ] = useState<number>(10)
    const [ rowSelected, setRowSelected ]           = useState<ReplacementPart>({} as ReplacementPart)
    const [ showModalConfirm, setShowModalConfirm ] = useState<boolean>(false)

    useEffect(()=>{
        getApi()
    },[search])

    const getApi = async () => {
        try {
          setLoading(true)
          let payload:any = {}
          if (search !== '') {
            payload = {
                ...payload,
                search
            }
          }
          await getReplacementParts(payload)
          setLoading(false)
        } catch (error) {
          setLoading(false)
        }
    }

    const onAdd = () => {
        setEditReplacementPart({} as ReplacementPart)
        navigate({ pathname: RoutesMap.REPLACEMENT_PART_FORM })
    }

    const onEdit = (rowSelected) => {
        setEditReplacementPart(rowSelected)
        navigate({ pathname: RoutesMap.REPLACEMENT_PART_FORM })
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async() => {
        const response = await deleteReplacementPart(rowSelected.id)
        if (response === true) {
            setEditReplacementPart({} as ReplacementPart)
            setShowModalConfirm(false)
            getApi()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (<>
        <Grid item xs={12}>
            <CustomTable 
                title={'Repuestos'}
                columns={columns || []}
                loading={loading}
                rows={replacementParts || []}
                onRowClick={() => {}}
                hasOptions
                onAddFn={onAdd}
                onDelete={onDelete}
                onEdit={onEdit}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Grid>
        {
            showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={()=>{setShowModalConfirm(false)}}
                    onCancel={()=>{setShowModalConfirm(false)}}
                    onConfirm={onDeleteConfirm}
                    status2={status === ApiStatus.FETCHING ? true : false}
                />
            )
        }
    </>)
}